module.exports = __webpack_public_path__ + "img/3c18ea1.png";